<script setup lang="ts">
    import { computed, toRef } from 'vue'
    import type { AlternativeFilterReadModel } from '@Alternatives/AlternativesViews/Domain/readmodels'
    import type { AlternativeStatusReadModel } from '@Alternatives/Statuses/Domain/readmodels'

    // ---------------- props / emits ----------------

    const props = defineProps<{
        propRm: AlternativeFilterReadModel
        propStatuses: AlternativeStatusReadModel[]
    }>()

    const emit = defineEmits<{
        (e: 'deleteFilter', rm: AlternativeFilterReadModel): void
    }>()

    // ---------------- shortcuts ----------------

    const rm = toRef(props, 'propRm')
    const statuses = toRef(props, 'propStatuses')

    // ---------------- derived ----------------

    const headerText = computed<string | null>(() =>
    {
        if (!rm.value.Data || rm.value.Data.length === 0)
            return 'Invalid!'

        const selectedStatuses = statuses.value
            .filter(s => rm.value.Data.indexOf(s.Name) !== -1)
            .map(s => s.Name)
            .sort()

        if (rm.value.Type === 'StatusIn')
            return `Status: ${selectedStatuses.join(', ')}`

        if (rm.value.Type === 'StatusNotIn')
            return `Status not in: ${selectedStatuses.join(', ')}`

        return null
    })

    // ---------------- methods ----------------

    function deleteFilter()
    {
        emit('deleteFilter', rm.value)
    }
</script>


<template>
    <div class="card" style="display: inline-block;">
        <div @click="rm.IsEdited = true" class="card-header pointer">
            {{headerText}}
        </div>
        <div v-if="rm.IsEdited" class="card-body">
            <div class="form-group">
                <label>Statuses:</label>
                <select class="form-control" multiple size="6" v-model="rm.Data">
                    <option v-for="s in statuses" :value="s.Name">{{ s.Name }}</option>
                </select>
            </div>
            <div class="d-flex justify-content-between">
                <div class="dropdown d-inline">
                    <button type="button" class="btn btn-outline-danger" data-toggle="dropdown">
                        Delete
                    </button>
                    <div class="dropdown-menu">
                        <div class="btn-group">
                            <button type="button" class="btn btn-outline-secondary">Cancel</button>
                            <button @click="deleteFilter" type="button" class="btn btn-danger">Confirm</button>
                        </div>
                    </div>
                </div>

                <button @click="rm.IsEdited = false" class="btn btn-primary">Update</button>
            </div>
        </div>
    </div>
</template>